import React, { useEffect, useState } from 'react';
import NotifierBanner from 'flow/components/custom-components/NotifierBanner';
import useAppContext from 'flow/hooks/useAppContext';
import { electronActions, electronListeners } from 'flow/utils/electron-utils';

const UpdateNotifier = () => {
    const { i18next } = useAppContext();
    const [updateDownloaded, setUpdateDownloaded] = useState(false);

    useEffect(() => {
        electronListeners.onUpdateDownloaded(() => setUpdateDownloaded(true));
    }, []);

    if (!updateDownloaded) {
        return null;
    }

    return (
        <NotifierBanner
            message={i18next.t('update.notifier.message')}
            buttonText={i18next.t('update.notifier.button')}
            handleClick={() => electronActions.updateAndRestart()}
        />
    );
};

export default UpdateNotifier;
